import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import Modal from '../../../../components/Modal';
import ClosableModal from '../../../../components/Modal/ClosableModal';
import Button from '../../../../components/Button';
import Form from '../../../../components/Form';
import Dropdown from '../../../../components/Dropdown';
import './styles.css';
import AddProfileForm from './addProfileForm';
import * as actions from '../../actions';
import {
  COLLEGE_PROFILE_TYPE_NAME_ALUMNI,
  COLLEGE_PROFILE_TYPE_NAME_FACULTY,
  COLLEGE_PROFILE_TYPE_NAME_PROGRAM,
  COLLEGE_PROFILE_TYPE_NAME_STUDENT,
} from '../../constants';

const PROFILE_TYPES = [
  { key: 'STUDENT_PROFILE', value: COLLEGE_PROFILE_TYPE_NAME_STUDENT, text: 'Student Spotlight' },
  { key: 'ALUMNI_PROFILE', value: COLLEGE_PROFILE_TYPE_NAME_ALUMNI, text: 'Alumni Spotlight' },
  { key: 'FACULTY_PROFILE', value: COLLEGE_PROFILE_TYPE_NAME_FACULTY, text: 'Faculty Spotlight' },
  { key: 'PROGRAM_PROFILE', value: COLLEGE_PROFILE_TYPE_NAME_PROGRAM, text: 'Program Spotlight' },
];

export const CreateProfile = ({ onClose, onContinue, onTypeChange, type }) => (
  <React.Fragment>
    <Modal.Header styleName="add-profile-modal-header">
      Create a New Spotlight
    </Modal.Header>
    <Modal.Content styleName="add-profile-modal-content">
      <Form id="create-profile-form">
        <div styleName="add-profile-modal-label">What type of spotlight would you like to create?</div>
        <Dropdown
          data-cy="Premium-Hem-Profiles-Type-Dropdown"
          selection
          options={PROFILE_TYPES}
          openOnFocus={false}
          value={type}
          onChange={onTypeChange}
        />
      </Form>
    </Modal.Content>
    <Modal.Actions>
      <Button content="Cancel" onClick={onClose} />
      <Button primary content="Next" onClick={onContinue} />
    </Modal.Actions>
  </React.Fragment>
);

CreateProfile.propTypes = {
  onClose: PropTypes.func.isRequired,
  onContinue: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  removeLearnMoreLink: PropTypes.func.isRequired,
};

export class AddProfileModalComponent extends React.Component {
  static propTypes = {
    onCloseModal: PropTypes.func.isRequired,
    linksAndProfilesChanges: PropTypes.array,
    openModal: PropTypes.bool.isRequired,
    addCustomProfile: PropTypes.func.isRequired,
  };

  state = {
    step: 0,
    type: COLLEGE_PROFILE_TYPE_NAME_STUDENT,
  };

  onTypeChange = (e, data) => {
    this.setState({ type: data.value });
  };

  onContinue = () => {
    this.setState({ step: 1 });
  };

  onCancel = () => {
    this.setState({
      step: 0,
      type: COLLEGE_PROFILE_TYPE_NAME_STUDENT,
    });
    this.props.onCloseModal();
  };

  createHubsProfiles = (profile) => {
    this.props.addCustomProfile(profile);
  };

  render() {
    const { step, type } = this.state;
    const { openModal } = this.props;
    return (
      <ClosableModal
        open={openModal}
        onClose={this.onCancel}
        styleName="add-profile-modal"
      >

        <React.Fragment>
          {step === 0 ? (
            <CreateProfile
              onClose={this.onCancel}
              onContinue={this.onContinue}
              onTypeChange={this.onTypeChange}
              type={type}
            />
          ) : null}
          {step === 1 && (
            <AddProfileForm
              onClose={this.onCancel}
              type={type}
              updateHubsCustomProfiles={this.createHubsProfiles}
            />
          )}
        </React.Fragment>
      </ClosableModal>
    );
  }
}

const mapStateToProps = (state) => ({
  addCustomProfile: get(state, 'nonPersistedCollegeProfile.linksAndProfiles.addCustomProfile'),
});

export default connect(mapStateToProps, { ...actions })(AddProfileModalComponent);
